import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { downloadFile, httpPost } from '../../../../components/utils';
import { useCallback, useState } from 'react';
import { HttpResponse } from '../../../../api/types/Http';

interface Filters {
    ruleName: string;
    daysDiff?: number;
    entitySourceType?: string;
    domainName?: string[];
    tenantFilter?: string[];
    riskLevel?: number[];
    riskIndicator?: string[];
    entityType?: number[];
    entityName?: string;
    entityStatus?: string[];
    platforms?: string[];
    sortField?: string;
    sortDirection?: string;
}

interface Params {
    onError?: () => void;
    fileName: string;
}

const downloadUrl = '/insights/downloadInsightEntitiesCsvFile';

const useGenerateInsightEntitiesFile = ({ onError, fileName }: Params) => {
    const [isGenerating, setIsGenerating] = useState(false);

    const downloadCsv = useCallback(
        async (ruleName: string, requestParams: Filters) => {
            setIsGenerating(true);
            try {
                const result = (await httpPost(`/insights/details/${ruleName}/generateCsv`, undefined, {
                    [HTTP_OPTIONS.REQ_OPTIONS]: {
                        params: requestParams
                    }
                })) as unknown as HttpResponse<{ responseID?: number }>;

                const responseID = result.data.responseID;

                if (!responseID) {
                    onError?.();
                    return;
                }

                downloadFile(`${downloadUrl}/${responseID}/${fileName}_${new Date().toISOString()}.csv`);
            } catch (err) {
                onError?.();
                setIsGenerating(false);
            }

            setIsGenerating(false);
        },
        [onError, fileName]
    );

    return { isGenerating, downloadCsv };
};

export default useGenerateInsightEntitiesFile;
